export const COOKIES = {
  LOGGED_IN: {
    NAME: 'logged_in',
    DURATION_SECONDS: 3600,
  },
};
